export default __webpack_public_path__ + "06.01.2016_Press_release_LifeTime_Seedfinancing197d2ff83476fd28d90504cfdd20a24d.pdf";